<script setup lang="ts">
defineOptions({ name: 'empty' })
</script>

<template>
  <div class="v-content-grid-item v-content-grid-item_empty"></div>
</template>
